export const ENV_NAME = 'production'
export const HOST_NAME = 'ops.mymove.be'
export const API_URL = 'https://api.pilot.mymove.be/ops-api'
